<!-- ========== Left Sidebar Start ========== -->
<div class="vertical-menu">

  <!-- LOGO -->
  <div class="navbar-brand-box">
    <a [routerLink]="['/', hotelId, 'dashboard']" class="logo logo-dark test" [attr.aria-label]="'common.go_to_dashboard' | translate">
      <span class="logo-sm">
        <img src="../../../assets/images/hotelcard-logo-no-text.svg" alt="{{ 'HEADER.HOTELCARD_LOGO' | translate }}" height="22"/>
      </span>
      <span class="logo-lg">
        <img src="../../../assets/images/hotelcard-logo.svg" alt="{{ 'HEADER.HOTELCARD_LOGO' | translate }}" height="22"/>
      </span>
    </a>
  </div>

  <button type="button" class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn" (click)="toggleMobileMenu($event)" [attr.aria-label]="'common.toggle_menu' | translate">
    <lucide-icon name="menu" aria-hidden="true"></lucide-icon>
  </button>

  <!--- Sidemenu -->
  <ngx-simplebar class="sidebar-menu-scroll">
    <div id="sidebar-menu">
      <ul class="metismenu list-unstyled" id="side-menu">
        @for (item of menuItems; track $index) {
          @if (hasMenuAccess(item)) {
            @if (item.isTitle) {
              @if (isSectionVisible($index)) {
                @if (showDividerBefore($index)) {
                  <li class="menu-divider" aria-hidden="true"></li>
                }
                <li class="menu-title">
                  {{ (item.label || '') | translate }}
                </li>
              }
            }
            @if (!item.isTitle && !item.isLayout) {
              <li>
                @if (hasItems(item)) {
                  <a href="javascript:void(0);"
                     class="is-parent"
                     [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
                     [ngbTooltip]="(item.label || '') | translate"
                     placement="right"
                     container="body"
                     tooltipClass="sidebar-tooltip">
                    <img [src]="item.icon" class="nav-icon-me nav-icon" alt="" aria-hidden="true"/>
                    <span class="menu-item">{{ (item.label || '') | translate }}</span>
                    @if (item.badge) {
                      <hc-badge [color]="item.badge.color || 'neutral'" size="small" variant="heavy" class="float-end">{{ item.badge.text | translate }}</hc-badge>
                    }
                  </a>
                  <ul class="sub-menu" aria-expanded="false">
                    @for (subitem of item.subItems; track $index) {
                      <li>
                        @if (hasItems(subitem)) {
                          <a class="side-nav-link-a-ref has-arrow" href="javascript:void(0);" [attr.data-parent]="subitem.parentId">
                            {{ (subitem.label || '') | translate }}
                          </a>
                          <ul class="sub-menu mm-collapse" aria-expanded="false">
                            @for (subSubitem of subitem.subItems; track $index) {
                              <li>
                                @if (hotelId) {
                                  <a
                                    [routerLink]="['/', hotelId, subSubitem.link]"
                                    class="side-nav-link-ref"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >
                                    {{ (subSubitem.label || '') | translate }}
                                  </a>
                                }
                              </li>
                            }
                          </ul>
                        } @else {
                          @if (hotelId) {
                            <a
                              [routerLink]="['/', hotelId, subitem.link]"
                              class="side-nav-link-ref"
                              routerLinkActive="active"
                              [routerLinkActiveOptions]="{ exact: true }"
                              >
                              {{ (subitem.label || '') | translate }}
                            </a>
                          }
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  @if (item.absolute) {
                    <!-- Absolute link: no hotel ID prefix (e.g. onboarding-requests) -->
                    <a [routerLink]="['/', item.link]"
                       class="side-nav-link-ref"
                       routerLinkActive="active"
                       [ngbTooltip]="(item.label || '') | translate"
                       placement="right"
                       container="body"
                       tooltipClass="sidebar-tooltip">
                      @if (item.icon) {
                        <img [src]="item.icon" class="nav-icon-me nav-icon" alt="" aria-hidden="true"/>
                      }
                      <span class="menu-item">{{ (item.label || '') | translate }}</span>
                      @if (item.badge) {
                        <hc-badge [color]="item.badge.color || 'neutral'" size="small" variant="heavy" class="float-end">{{ item.badge.text | translate }}</hc-badge>
                      }
                    </a>
                  } @else if (hotelId) {
                    <a [routerLink]="['/', hotelId, item.link]"
                       class="side-nav-link-ref"
                       routerLinkActive="active"
                       [ngbTooltip]="(item.label || '') | translate"
                       placement="right"
                       container="body"
                       tooltipClass="sidebar-tooltip">
                      @if (item.icon) {
                        <img [src]="item.icon" class="nav-icon-me nav-icon" alt="" aria-hidden="true"/>
                      }
                      <span class="menu-item">{{ (item.label || '') | translate }}</span>
                      <!-- Show badge ONLY for Booking requests menu and ONLY if pendingCount > 0 -->
                      @if (item.label === 'MENUITEMS.BOOKING_REQUESTS.TEXT' && pendingCount > 0) {
                        <hc-badge color="secondary" size="small" variant="heavy" class="float-end">{{ pendingCount }}</hc-badge>
                      }
                      @if (item.badge) {
                        <hc-badge [color]="item.badge.color || 'neutral'" size="small" variant="heavy" class="float-end">{{ item.badge.text | translate }}</hc-badge>
                      }
                    </a>
                  }
                }
              </li>
            }
          }
        }
      </ul>
    </div>
  </ngx-simplebar>

  <!-- Fixed Bottom Menu (Desktop) -->
  <div class="sidebar-bottom-menu d-none d-lg-block">
    <ul class="list-unstyled mb-0">
      @for (item of bottomMenuItems; track $index) {
        <li>
          @if (item.absolute) {
            <a [routerLink]="['/', item.link]" class="side-nav-link-ref" routerLinkActive="active">
              @if (item.icon) {
                <img [src]="item.icon" class="nav-icon-me nav-icon" alt="" aria-hidden="true"/>
              }
              <span class="menu-item">{{ (item.label || '') | translate }}</span>
            </a>
          }
          @if (!item.absolute && hotelId) {
            <a [routerLink]="['/', hotelId, item.link]" class="side-nav-link-ref" routerLinkActive="active">
              @if (item.icon) {
                <img [src]="item.icon" class="nav-icon-me nav-icon" alt="" aria-hidden="true"/>
              }
              <span class="menu-item">{{ (item.label || '') | translate }}</span>
            </a>
          }
        </li>
      }
    </ul>
  </div>

  <!-- Mobile Icon Strip (left side) -->
  <div class="sidebar-icon-strip d-lg-none">
    <!-- Language selector with dropdown -->
    <div class="icon-strip-item" ngbDropdown placement="right-bottom">
      <button type="button" class="icon-btn" ngbDropdownToggle [attr.aria-label]="'common.language' | translate">
        <img [src]="getCurrentFlag()" alt="" aria-hidden="true" height="20" />
      </button>
      <div class="dropdown-menu" ngbDropdownMenu>
        @for (lang of listLang; track lang) {
          <button
            type="button"
            class="dropdown-item d-flex align-items-center gap-2"
            [class.active]="languageService.getCurrentLanguage() === lang.lang"
            (click)="setLanguage(lang.lang)">
            <img [src]="lang.flag" [alt]="lang.name" height="16" />
            <span>{{ lang.name }}</span>
          </button>
        }
      </div>
    </div>

    <!-- Share -->
    <button type="button" class="icon-strip-item" (click)="copyShareLink()" [attr.aria-label]="'common.share_url' | translate">
      <lucide-icon name="share-2" aria-hidden="true"></lucide-icon>
    </button>

    <!-- Verify HotelCard validity -->
    <button type="button" class="icon-strip-item" (click)="openCardValidityDialog()" [attr.aria-label]="'dashboard.verify_card.title' | translate">
      <lucide-icon name="credit-card" aria-hidden="true"></lucide-icon>
    </button>

    <!-- Profile -->
    <a [routerLink]="['/user-profile']" class="icon-strip-item" routerLinkActive="active" [attr.aria-label]="'profile.my_profile' | translate">
      <lucide-icon name="user"></lucide-icon>
    </a>

    <!-- Notifications -->
    <a [routerLink]="['/notifications']" class="icon-strip-item" routerLinkActive="active" [attr.aria-label]="'MENUITEMS.NOTIFICATIONS.TEXT' | translate">
      <lucide-icon name="bell"></lucide-icon>
    </a>

    <!-- Help -->
    <a [routerLink]="['/', hotelId, 'help']" class="icon-strip-item" routerLinkActive="active" [attr.aria-label]="'MENUITEMS.HELP_SUPPORT.TEXT' | translate">
      <lucide-icon name="circle-help"></lucide-icon>
    </a>

    <!-- Logout -->
    <button type="button" class="icon-strip-item" (click)="logout()" [attr.aria-label]="'common.logout' | translate">
      <lucide-icon name="log-out"></lucide-icon>
    </button>
  </div>
</div>
<!-- Left Sidebar End -->
